export const API_URL = "https://ghumnejao.com/administration/admin/api"
// export const API_URL = "http://localhost:8080/administration/admin/api";
export const ImgUrl = "https://ghumnejao.com"
// export const ImgUrl = "http://localhost:8080";
export const blogImgUrl = "/administration/uploads/blog/";
export const packageImgUrl = "/administration/uploads/packages/";
export const bannerImgUrl = "/administration/uploads/banners/";
export const destinationImgUrl = "/administration/uploads/abc/";
export const themeImgUrl = "/administration/uploads/themes/";
export const referencePackageImgUrl = "/administration/uploads/packages/";



